var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.6,
    height: 52,
    viewBox: "0 0 41.6 52",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-file-pdf",
    transform: "translate(-6 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M12.809,22.02a3.894,3.894,0,0,0-.967.094v3.063a3.538,3.538,0,0,0,.785.061c1.245,0,2.012-.629,2.012-1.693,0-.952-.66-1.524-1.83-1.524Zm9.067.031a4.781,4.781,0,0,0-1.057.094v6.786a4.241,4.241,0,0,0,.815.047c2.123.016,3.507-1.154,3.507-3.63a2.975,2.975,0,0,0-3.262-3.3Z",
    transform: "translate(4.284 13.948)",
    fill: "#3a4d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M32,3H11.2A5.2,5.2,0,0,0,6,8.2V49.8A5.2,5.2,0,0,0,11.2,55H42.4a5.2,5.2,0,0,0,5.2-5.2V18.6ZM20.295,39.894a4.82,4.82,0,0,1-3.37,1.092,5.8,5.8,0,0,1-.8-.047v3.708H13.8V34.413a19.651,19.651,0,0,1,3.169-.213,4.978,4.978,0,0,1,3.172.83,3.041,3.041,0,0,1,1.108,2.4,3.341,3.341,0,0,1-.953,2.465Zm9.9,3.522a7.447,7.447,0,0,1-4.784,1.338,20.02,20.02,0,0,1-2.662-.156V34.415a20.662,20.662,0,0,1,3.17-.215,6.672,6.672,0,0,1,4.247,1.108,4.59,4.59,0,0,1,1.756,3.91,5.258,5.258,0,0,1-1.725,4.2ZM39.8,36.2H35.817v2.369H39.54V40.48H35.817v4.17H33.461V34.278H39.8ZM32,21.2H29.4V8.2l13,13Z",
    transform: "translate(0 0)",
    fill: "#3a4d6a"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf.d618897e0560045d940bbfb10725b265.svg";